import type { ForqFeatureManifest, ForqModuleManifest, NavigationIcon } from '@forq/contracts';
import { previewModuleDefinitions } from './catalog';

const navigationOrder: Readonly<Record<string, number>> = {
  service: 21,
  technician: 22,
  rental: 25,
  purchasing: 41,
  logistics: 50,
  documents: 70,
  finance: 80,
  messenger: 90,
  feedback: 91,
  forqy: 92,
  studio: 950,
};

// Zeichen aus dem FORQ Icon Pack v1, soweit es fuer den Bereich eines gibt. Alle uebrigen tragen
// weiterhin das allgemeine Modulzeichen -- fuer sie liegt noch kein eigenes vor.
const navigationIcons: Readonly<Record<string, NavigationIcon>> = {
  rental: 'mietpark',
  service: 'service',
  documents: 'dokumente',
  finance: 'finanzen',
  messenger: 'messenger',
  feedback: 'feedback',
  forqy: 'forqy',
  studio: 'studio',
};

const activePreviewDefinitions = previewModuleDefinitions.filter((definition) => definition.id !== 'orders');

export const completePreviewModule: ForqModuleManifest = {
  id: 'complete-preview',
  name: 'FORQ Gesamtübersicht',
  description: 'Alle Zielbereiche gesammelt prüfen und öffnen',
  version: '0.1.0',
  route: '/complete-preview',
  category: 'start',
  status: 'beta',
  requiredPermissions: ['preview.complete.view'],
  features: ['complete-preview.catalog'],
  navigation: [
    {
      id: 'complete-preview.launcher',
      label: 'Alle Module',
      route: '/complete-preview',
      placement: 'launcher',
      order: 1,
      icon: 'module',
    },
  ],
};

export const previewModules: readonly ForqModuleManifest[] = activePreviewDefinitions.map(
  (definition): ForqModuleManifest => ({
    id: definition.id,
    name: definition.name,
    description: definition.description,
    version: '0.1.0-preview',
    route: definition.route,
    category: definition.group,
    status: definition.readiness === 'platform-preview' ? 'planned' : 'development',
    requiredPermissions: [definition.permission],
    features: [`${definition.id}.preview`],
    navigation: [
      {
        id: `${definition.id}.primary`,
        label: definition.name,
        route: definition.route,
        placement: 'primary',
        order: navigationOrder[definition.id] ?? 500,
        icon: navigationIcons[definition.id] ?? 'module',
      },
      {
        id: `${definition.id}.launcher`,
        label: definition.name,
        route: definition.route,
        placement: 'launcher',
        order: navigationOrder[definition.id] ?? 500,
        icon: navigationIcons[definition.id] ?? 'module',
      },
    ],
  }),
);

export const completePreviewFeatures: readonly ForqFeatureManifest[] = [
  {
    id: 'complete-preview.catalog',
    moduleId: 'complete-preview',
    name: 'Gesamtübersicht',
    description: 'Alle Zielseiten und ihren Reifegrad gesammelt darstellen',
    version: '0.1.0',
    defaultEnabled: true,
    requiredPermissions: ['preview.complete.view'],
    uiSlots: [],
    emits: [],
    listensTo: ['tenant.changed'],
  },
  ...activePreviewDefinitions.map((definition): ForqFeatureManifest => ({
    id: `${definition.id}.preview`,
    moduleId: definition.id,
    name: `${definition.name} Vorschau`,
    description: definition.description,
    version: '0.1.0-preview',
    defaultEnabled: true,
    requiredPermissions: [definition.permission],
    uiSlots: [],
    emits: [`${definition.id}.preview.action`],
    listensTo: ['tenant.changed'],
  })),
];
